import { Grid, TextField, Typography, MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import React, { useState } from 'react';
import { constructIds, fieldDimensionOptions } from '../../../config/common';
import { getElementOnFocus } from '../../../store/global/selectors'
import { basic, validationMessages } from '../../../config/validations';
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { booleanOptions } from '../../../config/common';
import { invokePostService, setExpanded, setReRender } from '../../../store/global/actions';
import { validateNonAsciiChars } from '../../../utils/commonUtils';


export default function CreateSection({ onClose, onCompletion, profile }) {
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, control, setError, watch } = useForm();
    const elementOnfocus = useSelector(getElementOnFocus);
    const [loading, setLoading] = useState(false);

    const height = watch('height')
    const width = watch('width')

    const getElementId = (type) => {
        let id = '';
        constructIds.forEach(construct => {
            if (construct.type === type) id = construct.id;
        });
        return id;
    }


    const onCreate = async ({ name, description, visible, width, height }) => {
        setLoading(true);
        const sectionDataFormat = {
            name: name,
            type: getElementId("section"),
            parent: [],
            attributes: {
                desc: description
            },
        }
        if (visible !== "" && visible !== undefined) sectionDataFormat.attributes.visible = visible;

        // setting dimensions
        if (height !== '' && height !== undefined && width !== '' && width !== undefined) {
            sectionDataFormat.attributes.dimensions = `${width}x${height}`
        }

        dispatch(invokePostService('createProperty', { section: sectionDataFormat, isProfile: profile ? true : false, clusterletId: elementOnfocus.id })).then(res => {
            setLoading(false);
            if (res?.status) {
                onCompletion('Section', 'add', [], undefined, res?.data );
                dispatch(setReRender())
                dispatch(setExpanded("1"))
            } else {
                if (res?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    res?.errors.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                }
            }
        });
    }

    const messages = {
        ...validationMessages,
        validate: 'Clusterlet already has a property with the same name'
    }

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <Typography >Create new section</Typography>
            </Grid>

            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    variant="outlined"
                    placeholder={""}
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors?.name?.message : messages[errors?.name?.type] : ''}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="description"
                    type={"text"}
                    fullWidth
                    multiline={true}
                    rows={4}
                    label={"Description"}
                    placeholder={""}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false, validate: validateNonAsciiChars})}
                    error={errors?.description}
                    helperText={errors?.description?.message || ''}
                />
            </Grid>

            {/* width */}
            {profile !== true &&
                <Grid item xs={6}>
                    <Controller
                        id="width"
                        name="width"
                        control={control}
                        defaultValue={'12'}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="width"
                                label={'Width'}
                                select
                                fullWidth
                                variant={'outlined'}
                                value={value}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {fieldDimensionOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>
            }

            {/* height */}
            {profile !== true &&
                <Grid item xs={6}>
                    <Controller
                        id="height"
                        name="height"
                        control={control}
                        defaultValue={'12'}
                        render={({ field, value, onChange }) =>
                            <TextField
                                {...field}
                                name="height"
                                label={'Height'}
                                select
                                fullWidth
                                variant={'outlined'}
                                value={value}
                                onChange={e => { onChange(e) }}
                            >
                                <MenuItem key={123} value={""}>Select</MenuItem>
                                {fieldDimensionOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.title}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>
            }


            {profile !== true && <Grid item xs={12}>
                <Controller
                    name="visible"
                    control={control}
                    render={({ field, onChange }) =>
                        <TextField
                            {...field}
                            name="visible"
                            label={'Visibility'}
                            select
                            fullWidth
                            variant={'outlined'}
                            onChange={e => { onChange(e) }}
                        >
                            <MenuItem key={123} value={""}>Select</MenuItem>
                            {booleanOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.title}
                                </MenuItem>
                            ))}
                        </TextField>
                    }
                />
            </Grid>}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                <CreateCancel onCreate={handleSubmit(onCreate)} createDisable={loading} onCancel={onClose} content={loading ? 'Creating' : 'Create'} />
            </Grid>
        </Grid>

    )
}
